import { AutogenModelDriverEvents, AutogenRowDriverEvents } from "./autogen/AutogenModelDriverEvents";

export class ModelDriverEvents extends AutogenModelDriverEvents<RowDriverEvents> {
	constructor() {
		super(RowDriverEvents);
	}
}

export class RowDriverEvents extends AutogenRowDriverEvents {
}